<template>
    <div class="bg-white rounded-lg shadow p-2 mb-2">
        <div class="grid grid-cols-1 md:grid-cols-5 gap-4 items-end">
            <!-- Search -->
            <div class="md:col-span-2">
                <label class="block text-sm font-medium text-gray-700 mb-1">Căutare</label>
                <InputText data-cy="patients-search" v-model="local.search" class="w-full" placeholder="Nume / CNP / telefon..." />
            </div>

            <!-- Sex -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Sex</label>
                <Select data-cy="patients-sex" v-model="local.sex" :options="sexOptions" optionLabel="label" optionValue="value"
                    class="w-full" placeholder="Toți" />
            </div>

            <!-- Doctor -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Examinat de</label>
                <Select data-cy="patients-doctor" v-model="local.doctor" :options="doctorOptions" optionLabel="label" optionValue="value"
                    class="w-full" placeholder="Toți" :showClear="true" />
            </div>
        </div>

        <div class="grid grid-cols-1 md:grid-cols-5 gap-4 mt-2 items-end">
            <!-- Sort -->
            <div>
                <label class="block text-sm font-medium text-gray-700 mb-1">Sortare</label>
                <Select data-cy="patients-sort" v-model="local.sortBy" :options="sortOptions" optionLabel="label" optionValue="value"
                    class="w-full" />
            </div>

            <div class="md:col-span-4 flex justify-end">
                <Button data-cy="patients-reset" label="Resetează filtre" icon="pi pi-refresh" severity="secondary" outlined @click="reset" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { reactive, watch, computed } from "vue";
import InputText from "primevue/inputtext";
import Select from "primevue/select";
import Button from "primevue/button";

const props = defineProps({
    modelValue: {
        type: Object,
        required: true,
    },
    doctors: {
        type: Array,
        default: () => [],
    },
});

const emit = defineEmits(["update:modelValue"]);

const local = reactive({ ...props.modelValue });

watch(
    () => props.modelValue,
    (v) => Object.assign(local, v),
    { deep: true }
);

watch(
    local,
    () => emit("update:modelValue", { ...local }),
    { deep: true }
);

const sexOptions = [
    { label: "Toți", value: "all" },
    { label: "F", value: "F" },
    { label: "M", value: "M" },
];

const sortOptions = [
    { label: "Nume (A-Z)", value: "name_asc" },
    { label: "Nume (Z-A)", value: "name_desc" },
    { label: "Vizită (descrescător)", value: "last_desc" },
    { label: "Vizită (crescător)", value: "last_asc" },
];

const doctorOptions = computed(() => {
    const unique = [...new Set((props.doctors || []).filter(Boolean))].sort((a, b) =>
        a.localeCompare(b)
    );
    return [{ label: "Toți", value: null }, ...unique.map((d) => ({ label: d, value: d }))];
});

const reset = () => {
    Object.assign(local, {
        search: "",
        sex: "all",
        doctor: null,
        sortBy: "name_asc",
    });
};
</script>